import React, { useContext, useMemo, useState, useEffect } from 'react';
import "./news-detail.scss";
import { Link, useParams } from "react-router-dom";
import { Buffer } from 'buffer';
import { AppContext } from '../../services/translationContext';
import { Loader } from '../../components/loader/loader';
import axios from 'axios';
import XMLParser from 'react-xml-parser';

const api = process.env.REACT_APP_URL_API;
const textstring = `
<p>In the world of IT, where innovation and execution speed are crucial, the <b>mockup</b> plays a key role in the development process of software, applications, and websites. <br/>It’s not just a simple preliminary sketch but a <b>detailed visual representation</b> that brings an idea to life.</p><br/><h2><b>What is a Mockup?</b></h2><p>A mockup is a static model that represents the design of a project, typically created using specialized software like <b>Figma</b>, <b>Adobe XD</b>, or <b>Sketch</b>. <br/>Unlike a <b>wireframe</b>, which focuses on structure and functionality, a mockup includes visual details such as colors, fonts, images, and layouts.</p><p>The goal is to provide a <b>clear and realistic preview</b> of what the final product will look like, enabling all stakeholders – from designers to clients – to get a tangible glimpse of the project.</p><br/><h2><b>Technical Aspects of a Mockup</b></h2><ul><li><b>Resolution and fidelity</b>: Mockups are usually high-fidelity and include precise details like responsive layouts, custom fonts, and defined color palettes following design standards.</li><li><b>Integration with development tools</b>: Many design platforms, like Figma or Adobe XD, allow assets to be exported in formats compatible with development environments (CSS, HTML, or JSON).</li><li><b>Functionality simulation</b>: Some mockups include <b>basic interactivity</b>, such as clickable buttons or animations, to simulate real product behavior. This helps in testing user flows.</li><li><b>Cross-device compatibility</b>: Mockups are designed to adapt to <b>multiple platforms</b> (desktop, tablet, mobile) and reflect the technical characteristics of each device.</li></ul><div style='width:80%; margin: auto; padding: 2rem 0;'><img src='https://d3t3s6w5yvhc3g.cloudfront.net/images/blog/example-mockup.png' style='width:100%; filter: drop-shadow(2px 4px 6px #ccc);' alt='Mockup Example'></div><br/><h2><b>Why Mockups Are Crucial for IT Companies</b></h2><ul style='list-style: decimal'><li><b>Idea Visualization</b><br/>Mockups transform abstract concepts into <b>visual representations</b>, making it easier for clients and development teams to understand what the final product will look like. This visualization is particularly useful for gathering early feedback and making changes during the initial stages of a project.</li><li><b>Risk and Cost Reduction</b><br/>With a well-crafted mockup, potential errors or misunderstandings are identified before the actual development begins. Fixing a design during the prototyping phase is far less expensive than resolving issues in an already developed product.</li><li><b>Effective Communication</b><br/>Mockups act as a bridge between the various teams within an IT company – designers, developers, and managers – ensuring that everyone has a clear and shared vision of the project. They are also an excellent tool for <b>client communication</b>, reducing misunderstandings and increasing transparency.</li><li><b>Development Acceleration</b><br/>With a detailed mockup, developers have a precise visual guide for implementing the design, avoiding ambiguities and saving time during the coding phase.</li><li><b>User-Centric Focus</b><br/>Mockups allow for realistic testing of user experience (UX), optimizing navigation flows and improving interaction.</li><li><b>Marketing Support</b><br/>Mockups can be used for marketing purposes. Even before project completion, they can be shown to potential clients or investors to generate interest and secure funding.</li></ul><br/><h2><b>Benefits of Creating Mockups</b></h2><ul><li><b>Visual accuracy</b>: They precisely represent the final product, reducing misunderstandings.</li><li><b>Flexibility</b>: Design changes can be made in just a few clicks without affecting the code.</li><li><b>Cost reduction</b>: Identifying design or flow errors during the mockup phase is more economical than fixing them post-development.</li><li><b>Rapid iterations</b>: Mockups allow for quick revisions to adapt to changing requests or feedback.</li><li><b>Simplified collaboration</b>: Collaborative design tools (like Figma) enable multiple teams to work simultaneously on the project</li><li><b>Standardization</b>: They promote the adoption of consistent design guidelines across all company projects.</li></ul><br/><h2><b>How to Create an Effective Mockup</b></h2><p>For an IT company, creating an effective mockup requires advanced tools and a collaborative approach:</p><ul><li><b>Dedicated software</b>: Tools like <b>Figma</b> or <b>Adobe XD</b> enable the creation of interactive mockups.</li><li><b>Team involvement</b>: Designers, developers, and stakeholders must work together to ensure the mockup meets everyone’s needs.</li><li><b>Usability testing</b>: Once created, the mockup can be used to simulate user experience and optimize the design.</li></ul><br/><p>Creating mockups is not just a good practice but a <b>strategic approach</b> to optimize workflow, enhance product quality, and ensure client satisfaction. Thanks to their technical features and numerous advantages, mockups are a crucial phase for IT companies aiming to stay competitive and deliver successful projects.</p><p>Adopting this approach means not only preventing errors but also speeding up development and improving communication among all project stakeholders. <b>A good mockup is the beginning of great results!</b></p>
`;

// https://d3t3s6w5yvhc3g.cloudfront.net/media/presentazione-hd.mp4

export const NewsDetail = () => {
  // let { news_id } = useParams();
  // const { services: {TranslationsService} } = useContext(AppContext);
  // const [newsInfo, setNewsInfo] = useState([]);
  // const [showLoader, setShowLoader] = useState(false);

  // useMemo(() => {
  //   setShowLoader(true);
  //   fetch(`${api}/content-public?url_path=${news_id}`)
  //   .then(response => response.json())
  //   .then(data => {
  //     setNewsInfo(data.data[0]);
  //     document.title = `${TranslationsService.labels(`client_stories`)} - ${data.data[0].title} | ${TranslationsService.getMainInfoCompany('name')}`;
  //     setShowLoader(false);
  //   });
  // }, [TranslationsService, news_id]);

  // const getHtmlContent = () => {
  //   try{
  //     let htmlText = Buffer.from(newsInfo.content, "base64");
  //     return htmlText;
  //   }
  //   catch(e){
  //     return '';
  //   }

  // }

  // return (
  //   <div className="section-home light">
  //     {
  //       showLoader &&
  //       <Loader />
  //     }
  //     <section className='hero-story-det syd-hero position-relative p-0' style={{backgroundImage:newsInfo.image?`url(https://d3t3s6w5yvhc3g.cloudfront.net/images/${newsInfo.image})`:''}}>
  //       <div className='overlay-area-info w-100 d-flex flex-column justify-content-center p-5'>
  //         <p className='dark-mode-text m-0 breadcrumb-detail'>
  //           <Link to='/' className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
  //           &nbsp;&#9656;&nbsp;
  //           <Link to='/sydea-blog' className='text-deco-none dark-mode-text transition-03s-eio'>Blog</Link>
  //         </p>
  //         <h2 className='syd-title light text-uppercase'>{newsInfo.title}</h2>
  //         <p className='dark-mode-text fs-1 m-0'>{newsInfo.description}</p>
  //       </div>
  //     </section>

  //     <div dangerouslySetInnerHTML={{ __html: getHtmlContent() }} className='w-100 p-3 area-text-cs'></div>
  //   </div>
  // );

  let { news_id, lang } = useParams();
  const { services: {TranslationsService} } = useContext(AppContext);
  const [newsInfo, setNewsInfo] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [posts, setPosts] = useState([]);
  const [error, setError] = useState(null);

  // useEffect(() => {
  //   const fetchPosts = async () => {
  //     try {
  //       const response = await axios.get('https://www.carloliaci.com/feed', {
  //         headers: {'Content-Type': 'application/xml; charset=utf-8'},
  //       });

  //       const xml = new XMLParser().parseFromString(response.data);
  //       const items = xml.getElementsByTagName('item');

  //       setPosts(items);
  //       console.log(items);
  //     } catch (error) {
  //       setError('Errore nel fetch dei dati: ' + error.message);
  //     } finally {
  //       setShowLoader(false);
  //     }
  //   };

  //   fetchPosts();
  // }, []);

  useMemo(() => {
    setTimeout(() => {
      const story = TranslationsService.labels(`blog_sect`).filter(x => x.id === news_id)[0];
      setNewsInfo(story);
      document.title = `Blog - ${story.title} | ${TranslationsService.getMainInfoCompany('name')}`;
    }, 10);
  }, [TranslationsService, news_id]);

  return (
    <div className="section-home light">
      {
        showLoader &&
        <Loader />
      }
      <section className='hero-story-det syd-hero position-relative p-0' style={{backgroundImage: `url(${newsInfo.image_url})`}}>
        <div className='overlay-area-info w-100 d-flex flex-column justify-content-center p-5'>
          <div className='box-text-section'>
            <div className='area-text-section'>
              <p className='dark-mode-text m-0 breadcrumb-detail'>
                <Link to={`/${lang}`}  className='text-deco-none dark-mode-text transition-03s-eio'>Home</Link>
                &nbsp;&#9656;&nbsp;
                <Link to={`/${lang}/insights`} className='text-deco-none dark-mode-text transition-03s-eio'>{TranslationsService.labels(`menu.insights.label`)}</Link>
                &nbsp;&#9656;&nbsp;
                <Link to={`/${lang}/insights/blog`} className='text-deco-none dark-mode-text transition-03s-eio'>Blog</Link>
              </p>
              <h2 className='title-insights-section text-uppercase'>{newsInfo.title}</h2>
              {/* <p className='dark-mode-text fs-4 m-0'>{newsInfo.desc}</p> */}
              <div className='insights-desc-box'>
                <div className='box-line-insights-desc'>
                  <div className='line-insights-desc'></div>
                </div>
                <div className='box-text-insights-desc'>
                  <div className='box-format-text-insights'>
                    <p className='dark-mode-text fs-5 m-0'>{newsInfo.desc}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className='body-text p-3 area-text-cs fs-5'>
        {/* <div dangerouslySetInnerHTML={{ __html: textstring }}></div> */}
        <div dangerouslySetInnerHTML={{ __html: newsInfo.long_text }}></div>
      </div>

      {/* <div>
        <h1>WordPress Posts</h1>
        <ul>
          {posts.map((post, index) => (
            <li key={index}>
              <h2>{post.title[0]}</h2>
              <div dangerouslySetInnerHTML={{ __html: post.description[0] }} />
            </li>
          ))}
        </ul>
      </div> */}

      {/* <div dangerouslySetInnerHTML={{ __html: getHtmlContent() }} className='w-100 p-3 area-text-cs'></div> */}
    </div>
  );
};
